var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"frontpage-button",class:[
    { 'frontpage-button--borderless' : _vm.borderless },
    { 'frontpage-button--light' : _vm.light },
    { 'frontpage-button--christmas': _vm.isChristmas } ],on:{"click":_vm.emitClick}},[_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")]),(!_vm.isChristmas)?_c('img',{staticClass:"frontpage-button__arrow",attrs:{"alt":"","src":_vm.icons.arrowRightWildWhite}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }